import React, { useMemo, useState } from 'react';
import { OrgsColumns } from '../columns/OrgsColumns';
import { UsersDataGrid } from '../components/UsersDataGrid';
import pluralize from 'pluralize';
import { useUserManagementContext } from '../context/UserManagementContext';
import { useOrganizations } from '../hooks';

export default function OrganizationsPage() {
  const { openEditOrgDrawer } = useUserManagementContext();
  const { data: organizations } = useOrganizations();

  const totalRows = organizations?.pagination.totalCount || 0;
  const title = pluralize('Team', totalRows, true);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const columnsWithProps = useMemo(
    () =>
      OrgsColumns.map((col: any) => {
        if (col.field === 'edit') {
          col.onClick = (rowId: string) => {
            const organization = organizations?.data.find(o => o.id === rowId);
            if (organization) {
              openEditOrgDrawer(organization);
            }
          };
        }

        return col;
      }),
    [organizations, openEditOrgDrawer],
  );

  return (
    <UsersDataGrid
      title={title}
      loading={!organizations}
      columns={columnsWithProps}
      // @ts-ignore
      rows={organizations?.data}
      create="organisation"
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
    />
  );
}
